// used for 'Notch' safe top padding:
import { useIsSmallScreen } from '../../system/SystemMediaQueriesProvider';

export interface IHookSafePadding {
  safeTopPadding: number;
}

export function useSafePadding(): IHookSafePadding {
  const isSmall = useIsSmallScreen();
  const safeTopPadding = Math.max(
    Math.abs(
      parseInt(
        getComputedStyle(document.documentElement).getPropertyValue('--sat'),
      ) ?? 22,
    ),
    isSmall ? 0 : 0,
  );
  return {
    safeTopPadding,
  };
}
